import React, { memo, useCallback } from 'react';
import { SearchBar } from '@Sage/hoi-poi-ui';

import EntityMenu from 'containers/components/EntityMenu';

import { getLiteral } from 'utils/getLiteral';

import './ProductsMenuHeader.scss';

const ProductsMenuHeader = memo(({ config, dispatch, entity, filterKey, searchText }) => {
    const onChangeSearchInput = useCallback(
        (e, context) => {
            const value = e?.target?.value || '';
            if (context?.action === 'clear') {
                dispatch({ type: 'changeSearchInput', value });
            }
        },
        [dispatch],
    );

    const onBlurSearchInput = useCallback(
        (e) => {
            dispatch({ type: 'changeSearchInput', value: e?.target?.value || '' });
        },
        [dispatch],
    );

    return (
        <div className="products-modal-header">
            <EntityMenu
                entity={entity}
                filterKey={filterKey}
                withFilters={true}
                quickFilters={config.quickFilters}
                searchComponent={
                    <SearchBar
                        className="products-modal-header__search"
                        inputValue={searchText}
                        onBlur={onBlurSearchInput}
                        onChange={onChangeSearchInput}
                        placeholder={getLiteral('action_searchproduct')}
                        useAsSimpleSearch
                    />
                }
                help={config.help}
            />
        </div>
    );
});

export default ProductsMenuHeader;
